export const DIALOG_TYPE = 'growth-canvas';
export const OPT_OUT_TRIAL_CANVAS_TYPE = 'opt_out_trial';
export const START_TRIAL_ACTION_ID = 'start_trial';

export enum OptOutTrialVariantEnum {
  vibrant_cta = 'vibrant_cta',
}
